import {
    collectGrowthVisitorMetadata,
    type GrowthVisitorMetadata,
} from '../../events/growth/growthVisitorMetadata';
import MixpanelFacade from '../../events/mixpanel/MixpanelFacade';
import { getStatsigStableId } from '../../feature-flags/StatsigStableIdCapture';

export interface VisitorMetadata extends GrowthVisitorMetadata {
    mixpanelDistinctId?: string;
    statsigStableId?: string;
}

export const collectVisitorMetadata = async (): Promise<VisitorMetadata> => {
    const growth = collectGrowthVisitorMetadata();
    const mixpanelDistinctId = (await MixpanelFacade.getDistinctId())?.trim();
    const statsigStableId = getStatsigStableId()?.trim();

    return {
        ...growth,
        ...(mixpanelDistinctId != null && mixpanelDistinctId !== ''
            ? { mixpanelDistinctId }
            : {}),
        ...(statsigStableId != null && statsigStableId !== ''
            ? { statsigStableId }
            : {}),
    };
};
